import { referenceDisplay } from '@seen/core/display'
import type * as appointmentsModel from '@seen/core/models/appointments/index'
import { DotSeparator } from '@seen/ui'
import { Fragment, type ReactNode } from 'react'
import { HoverPractitioner } from '#src/components/core/hover-card/HoverPractitioner.tsx'
import { TextLink } from '#src/components/core/TextLink.tsx'
import { useCreatedBy } from '#src/hooks/useCreatedBy.ts'
import { TimelineTextEntry } from '#src/pages/participants/timeline/TimelineTextEntry.tsx'
import { buildAppointmentRelativeUrl } from '#src/stores/calendar.ts'

export function RecurringAppointmentTimelineItem({
  appointments,
}: {
  appointments: appointmentsModel.ExtendedAppointment[]
}): ReactNode {
  const firstAppointment = appointments[0]
  const [healthcareService] = firstAppointment.healthcareServices

  const { data: createdBy, isLoading: createdByIsLoading } = useCreatedBy(
    firstAppointment.reference
  )
  const isCancelled = appointments.some((a) => a.isCancelled)

  return (
    <TimelineTextEntry
      actor={createdBy ?? 'Unknown'}
      actorIsLoading={createdByIsLoading}
      time={firstAppointment.lastUpdated}
      action={
        <>
          {isCancelled ? 'cancelled a' : 'booked a'}{' '}
          <TextLink to={buildAppointmentRelativeUrl(firstAppointment)}>
            recurring appointment
          </TextLink>{' '}
          with{' '}
          {firstAppointment.practitioners.map((p, index) => (
            <Fragment key={p.reference}>
              {index > 0 && ' & '}
              <HoverPractitioner practitioner={p} />
            </Fragment>
          ))}
          {!!healthcareService && (
            <>
              <DotSeparator />
              {referenceDisplay(healthcareService)}
            </>
          )}
        </>
      }
      reference={firstAppointment.reference}
      originTask={firstAppointment.queuedEditsOriginTask}
    />
  )
}
